import TaskCard from "../../components/task-card";
import { useSearchParams } from "react-router-dom";
import { RiRefreshLine } from "@remixicon/react";
import { useTranslation } from "react-i18next";
import Loading from "@/components/custom/loading";
import { MaintenanceTask } from "@/lib/types";
import { useState } from "react";

const INITIAL_TASK_COUNT = 3;

const Tasks = ({
  tasks,
  isPending,
  refetchTasks,
}: {
  tasks: MaintenanceTask[];
  isPending: boolean;
  refetchTasks: () => void;
}) => {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const [showAll, setShowAll] = useState(false);

  const date = searchParams.get("date") || new Date();
  const displayedTasks = showAll ? tasks : tasks.slice(0, INITIAL_TASK_COUNT);
  const hasMore = tasks.length > INITIAL_TASK_COUNT;

  return (
    <div className="mt-5 flex flex-col items-center justify-center px-5">
      <div className="flex w-full flex-row items-center justify-between">
        <h2 className="w-full text-start text-[15px] font-semibold leading-[15px] tracking-wide text-white">
          {t("title.tasks").toLocaleUpperCase(i18n.language)}
        </h2>
        <button
          onClick={() => {
            refetchTasks();
          }}
          className="text-white"
          data-testid="refresh-button"
        >
          <RiRefreshLine size={18} />
        </button>
      </div>

      <div className="flex w-full flex-col items-center justify-center gap-[10px] py-3">
        {isPending ? (
          <Loading />
        ) : (
          <>
            <div className="flex h-full w-full flex-1 flex-col items-start gap-[10px]">
              {hasMore && showAll && (
                <button
                  type="button"
                  onClick={() => setShowAll(false)}
                  className="w-full rounded-md border border-white/30 bg-white/10 py-2 text-sm font-medium text-white"
                  data-testid="show-less-tasks"
                >
                  {t("navigation.less")}
                </button>
              )}
              {displayedTasks.map((task) => (
                <TaskCard
                  redirectPath={`?date=${date}`}
                  key={task.id}
                  task={task}
                />
              ))}
              {hasMore && !showAll && (
                <button
                  type="button"
                  onClick={() => setShowAll(true)}
                  className="w-full rounded-md border border-white/30 bg-white/10 py-2 text-sm font-medium text-white"
                  data-testid="show-more-tasks"
                >
                  {t("navigation.more")}
                </button>
              )}
            </div>

            {tasks.length === 0 && (
              <div className="flex w-full flex-col items-center justify-center gap-[10px]">
                <p className="text-white">{t("label.no_tasks_found")}</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Tasks;
